import { ISpeedMessage } from '@Encore-FastStartup-Phase-Out/encore-shared';
import { makeAutoObservable } from 'mobx';

import { SpeedMessageApi } from '../api/SpeedMessageApi';
import { ChatQueryDto } from '../constants/types';

export class SpeedMessageStore {
  api: SpeedMessageApi;
  speedMessages: ISpeedMessage[] = [];
  loading: boolean = false;
  totalSpeedMessages: number = 0;
  speedMessagesSearch: string = '';

  constructor() {
    this.api = new SpeedMessageApi();
    makeAutoObservable(this, undefined, { autoBind: true });
  }

  setSpeedMessages(activeAuctionMessages: ISpeedMessage[]) {
    this.speedMessages = activeAuctionMessages;
  }

  setLoading(loading: boolean) {
    this.loading = loading;
  }

  setTotalSpeedMessages(value: number) {
    this.totalSpeedMessages = value;
  }

  setSpeedMessagesSearch(search: string) {
    this.speedMessagesSearch = search;
  }

  async fetchSpeedMessages(query?: Partial<ChatQueryDto>) {
    query = {
      ...(this.speedMessagesSearch && {
        search: this.speedMessagesSearch,
      }),
      ...(query || {}),
    };

    this.setLoading(true);
    const res = await this.api.getSpeedMessages(query);
    this.setTotalSpeedMessages(res.count);
    if (query?.page === 1) {
      this.setSpeedMessages(res.items);
    } else {
      this.setSpeedMessages([...this.speedMessages, ...res.items]);
    }
    this.setLoading(false);
  }

  async deleteSpeedMessage(id: string) {
    this.setLoading(true);
    await this.api.deleteSpeedMessage(id);
    const index = this.speedMessages.findIndex((msg) => msg.id === id);
    if (index !== -1) {
      this.speedMessages.splice(index, 1);
      this.setTotalSpeedMessages(this.totalSpeedMessages - 1);
    }
    this.setLoading(false);
  }

  async createSpeedMessage(text: string) {
    this.setLoading(true);
    const createdSpeedMessage = await this.api.createSpeedMessage({ text });
    this.speedMessages.unshift(createdSpeedMessage);
    this.setLoading(false);
  }

  async updateSpeedMessage(id: string, text: string) {
    this.setLoading(true);
    const updatedSpeedMessage = await this.api.updateSpeedMessage(id, { text });
    const index = this.speedMessages.findIndex((msg) => msg.id === id);
    if (index !== -1) {
      this.speedMessages[index] = updatedSpeedMessage;
    }
    this.setLoading(false);
  }
}
